import { ROUTES as e } from "@editor/ui-utils";
//#endregion
//#region src/index.ts
var t = {
	messages: {
		en: { kim: { openButton: "Open Kim" } },
		de: { kim: { openButton: "Kim öffnen" } }
	},
	routes: [{
		path: `/${e.kim.path}`,
		meta: { i18RouteTitleKey: e.kim.path },
		children: [{
			path: "",
			name: "kim_entrypoint",
			component: () => import("./kim-entrypoint.view-DZKBReTT.js"),
			meta: { requiredRight: "kim:navigate" }
		}]
	}],
	contentBlocks: []
};
//#endregion
export { t as kimModule };

//# sourceMappingURL=index.es.js.map